<template>
  <form @submit.prevent="submit">
    <modal-card :title="'Site secret'" :processing="processing">
      <section>
        <b-field
          :type="!formLabelIsValid ? 'is-danger' : ''"
          :message="!formLabelIsValid ? 'Please fill out this field.' : ''"
          label="Secret label *"
        >
          <b-input
            ref="label"
            v-model="form.label"
            :disabled="processing"
            required
            type="text"
            placeholder="eg. Username"
            @input="labelChanged = true"
          />
        </b-field>

        <b-field
          :type="!formValueIsValid ? 'is-danger' : ''"
          :message="!formValueIsValid ? 'Please fill out the field.' : ''"
          label="Secret value *"
        >
          <b-input
            v-model="form.value"
            :disabled="processing"
            type="password"
            password-reveal
            required
            placeholder="eg. Jon Snow"
            @input="valueChanged = true"
          />
        </b-field>

        <p v-if="!form.note.length && !showNoteField" class="has-text-centered">
          <a class="has-text-grey" @click="showNoteField = true">
            <u>Add a note about this secret</u>
          </a>
        </p>

        <b-field v-if="form.note.length || showNoteField" label="Note">
          <b-input
            v-model="form.note"
            :disabled="processing"
            type="textarea"
            placeholder="eg. This is the username to access my admin area..."
            expanded
          />
        </b-field>

        <b-field v-if="isOwner">
          <b-checkbox
            v-model="form.isHiddenFromDelegates"
            :disabled="processing"
            >Hide from delegates</b-checkbox
          >
        </b-field>
      </section>
      <button
        slot="footer"
        :class="{ 'is-loading': processing }"
        :disabled="formIsDisabled"
        type="submit"
        class="button is-success"
      >
        Save
      </button>
    </modal-card>
  </form>
</template>

<script>
export default {
  props: {
    siteId: {
      type: String,
      required: true
    },
    secret: {
      type: Object,
      default: () => {
        return {
          label: "",
          value: "",
          note: "",
          isHiddenFromDelegates: false
        };
      }
    }
  },
  data() {
    return {
      processing: false,
      labelChanged: false,
      valueChanged: false,
      form: this.$_.clone(this.secret),
      showNoteField: false
    };
  },
  computed: {
    isOwner() {
      return (
        this.$store.getters["sites/site/userRole"](this.siteId) === "owner"
      );
    },
    formLabelIsValid() {
      if (!this.labelChanged) {
        return true;
      }
      return this.form.label.length > 0;
    },
    formValueIsValid() {
      if (!this.valueChanged) {
        return true;
      }
      return this.form.value.length > 0;
    },
    formIsValid() {
      return this.formLabelIsValid && this.formValueIsValid;
    },
    formIsDisabled() {
      return !this.formIsValid || this.processing;
    },
    secretExists() {
      return this.$_.has(this.form, "_id");
    },
    isSecretDecoded() {
      return this.$_.has(this.form, "state") && this.form.state === "decoded";
    }
  },
  created() {
    this.$nextTick(() => {
      this.$refs.label.$el.querySelector("input").focus();
    });
  },
  mounted() {
    this.decodeValue();
  },
  methods: {
    decodeValue() {
      if (!this.secretExists || this.isSecretDecoded) {
        return;
      }
      const value = this.form.value;
      this.processing = true;
      this.form.value = "Decoding...";
      this.$store
        .dispatch("sites/decodeValue", {
          siteId: this.form.siteId,
          value: value,
          secretId: this.form._id
        })
        .then(result => {
          this.$set(this.form, "state", "decoded");
          this.$set(this.form, "value", result.value);
        })
        .catch(error => {
          this.$set(this.form, "value", value);
          this.$emit("close");
          this.$toast.open({
            message: `${error.message}`,
            position: "is-bottom",
            type: "is-danger",
            queue: false
          });
        })
        .finally(() => {
          this.processing = false;
        });
    },
    submit() {
      this.labelChanged = true;
      this.valueChanged = true;
      if (this.formIsDisabled) {
        return;
      }
      let action = "sites/addSecret",
        params = {
          siteId: this.siteId,
          secret: this.form
        };
      if (this.secretExists) {
        action = "sites/updateSecret";
        params.secretId = this.form._id;
      }

      this.processing = true;
      this.$store
        .dispatch(action, params)
        .then(result => {
          this.$emit("close");
          this.$toast.open({
            message: result.message,
            position: "is-bottom",
            type: "is-success",
            queue: false
          });
        })
        .catch(error => {
          this.processing = false;
          this.$toast.open({
            message: `${error.message}`,
            position: "is-bottom",
            type: "is-danger",
            queue: false
          });
        });
    }
  }
};
</script>
